import { instagramFragment } from "@saleor/fragments/instagram";
import {
  productFragmentDetails,
  productInsFrament
} from "@saleor/fragments/products";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  InseditBulkUpdate,
  InseditBulkUpdateVariables
} from "./types/InseditBulkUpdate";
import { InstagCreate, InstagCreateVariables } from "./types/InstagCreate";
import { InsTagDelete, InsTagDeleteVariables } from "./types/InsTagDelete";
import {
  InstagramBulkDeleteTag,
  InstagramBulkDeleteTagVariables
} from "./types/InstagramBulkDeleteTag";
import {
  InstagramCopyFromProducts,
  InstagramCopyFromProductsVariables
} from "./types/InstagramCopyFromProducts";
import {
  InstagramCreateProductins,
  InstagramCreateProductinsVariables
} from "./types/InstagramCreateProductins";
import {
  InstagramUpdate,
  InstagramUpdateVariables
} from "./types/InstagramUpdate";
import {
  InstagramVisibleProductIns,
  InstagramVisibleProductInsVariables
} from "./types/InstagramVisibleProductIns";
import { InsTagUpdate, InsTagUpdateVariables } from "./types/InsTagUpdate";
import {
  ProductVisibleProductIns,
  ProductVisibleProductInsVariables
} from "./types/ProductVisibleProductIns";
import {
  UnassignInstagramProduct,
  UnassignInstagramProductVariables
} from "./types/UnassignInstagramProduct";

const inseditBulkUpdate = gql`
  mutation InseditBulkUpdate($ids: [ID]!, $published: Boolean!) {
    inseditBulkUpdate(ids: $ids, published: $published) {
      errors {
        message
      }
    }
  }
`;
export const useInstagramBulkPublish = makeMutation<
  InseditBulkUpdate,
  InseditBulkUpdateVariables
>(inseditBulkUpdate);

const instagramUpdate = gql`
  mutation InstagramUpdate($id: ID!, $input: InstagramUpdateInput!) {
    inseditUpdate(id: $id, input: $input) {
      errors: instagramErrors {
        code
        field
      }
    }
  }
`;

export const useInstagramUpdate = makeMutation<
  InstagramUpdate,
  InstagramUpdateVariables
>(instagramUpdate);

const unassignInstagramProduct = gql`
  ${instagramFragment}
  mutation UnassignInstagramProduct($instagramId: ID!, $productIds: [ID]!) {
    instagramRemoveProducts(instagramId: $instagramId, products: $productIds) {
      instagram {
        ...InstagramFragment
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useUnassignInstagramProductMutation = makeMutation<
  UnassignInstagramProduct,
  UnassignInstagramProductVariables
>(unassignInstagramProduct);

const instagramCreateProductins = gql`
  ${instagramFragment}
  mutation InstagramCreateProductins($instagramId: ID!, $products: [ID]!) {
    instagramAddProductCreate(instagramId: $instagramId, products: $products) {
      instagram {
        ...InstagramFragment
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useInstagramCreateProductinsMutation = makeMutation<
  InstagramCreateProductins,
  InstagramCreateProductinsVariables
>(instagramCreateProductins);

const insTagCreate = gql`
  ${instagramFragment}
  mutation InstagCreate($input: InsTagCreateInput!, $instagramId: ID!) {
    instagCreate(input: $input, instagramId: $instagramId) {
      instagram {
        ...InstagramFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useInstagCreateMutation = makeMutation<
  InstagCreate,
  InstagCreateVariables
>(insTagCreate);

const insTagDelete = gql`
  ${instagramFragment}
  mutation InsTagDelete($id: ID!) {
    instagDelete(id: $id) {
      instagram {
        ...InstagramFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useInsTagDeleteMutation = makeMutation<
  InsTagDelete,
  InsTagDeleteVariables
>(insTagDelete);

const insTagUpdate = gql`
  ${instagramFragment}
  mutation InsTagUpdate($id: ID!, $input: InsTagUpdateInput!) {
    instagUpdate(id: $id, input: $input) {
      instagram {
        ...InstagramFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useInsTagUpdateMutation = makeMutation<
  InsTagUpdate,
  InsTagUpdateVariables
>(insTagUpdate);

const instagramBulkDeleteTag = gql`
  ${instagramFragment}
  mutation InstagramBulkDeleteTag($ids: [ID]!) {
    instagramBulkDeleteTag(ids: $ids) {
      instagram {
        ...InstagramFragment
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useInstagramBulkDeleteTagMutation = makeMutation<
  InstagramBulkDeleteTag,
  InstagramBulkDeleteTagVariables
>(instagramBulkDeleteTag);

const instagramVisibleProductIns = gql`
  ${productFragmentDetails}
  ${productInsFrament}
  mutation InstagramVisibleProductIns($ids: [ID]!) {
    instagramVisibleProductIns(ids: $ids) {
      product {
        ...Product
        productIns(isOrder: "true") {
          ...ProductInsFrament
        }
        productSortIns {
          ...ProductInsFrament
        }
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useInstagramVisibleProductInsMutation = makeMutation<
  InstagramVisibleProductIns,
  InstagramVisibleProductInsVariables
>(instagramVisibleProductIns);

const instagramCopyFromProducts = gql`
  ${productFragmentDetails}
  ${productInsFrament}
  mutation InstagramCopyFromProducts($id: ID!, $ids: [ID]!) {
    instagramCopyFromProducts(id: $id, ids: $ids) {
      product {
        ...Product
        productIns(isOrder: "true") {
          ...ProductInsFrament
        }
        productSortIns {
          ...ProductInsFrament
        }
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useInstagramCopyFromProductsMutation = makeMutation<
  InstagramCopyFromProducts,
  InstagramCopyFromProductsVariables
>(instagramCopyFromProducts);

const productVisibleProductIns = gql`
  ${instagramFragment}
  mutation ProductVisibleProductIns($ids: [ID]!) {
    productVisibleProductIns(ids: $ids) {
      instagram {
        ...InstagramFragment
      }
      errors {
        message
        field
      }
    }
  }
`;
export const useProductVisibleProductInsMutation = makeMutation<
  ProductVisibleProductIns,
  ProductVisibleProductInsVariables
>(productVisibleProductIns);
